import { Inject } from '@odinjs/odin';

import { APPLICATION_ROUTES, Endpoint, FOUNDATION_ROUTES, Route } from '@philips-emr/hpms-provider-accreditation-commons';
import { HPMSOnSubmitTermUse } from '@philips-emr/hpms-provider-accreditation-components';
import { FetchAPI } from '@philips-emr/tws-components';
import Controller, { OnClose, OnMount } from '@philips-emr/tws-core/lib/client';
import { AuthenticationService, HttpService } from '@philips-emr/tws-core/lib/services';

import BaseController from './BaseController';

interface Term {
  nrSequence: number;
}

@Controller({ fragment: 'assign-privacy-warning', component: 'assign-privacy-warning-modal' })
class AssignPrivacyWarningModalController extends BaseController {

  @Inject('fetch-hpms-privacy-warning')
  private fetchPrivacy: FetchAPI;

  @OnMount('assign-privacy-warning-modal')
  onMount(): void {
    const { nrSeqPrivacy } = this.historyService.getCurrentRouteParams();
    this.context.set({ nrSeqPrivacy });
    const nrSeqValid = nrSeqPrivacy !== 'undefined';
    if (nrSeqValid) {
      this.fetchPrivacy.forceFetch();
    }
  }

  @OnClose('assign-privacy-warning-modal')
  onclose(): void {
    void AuthenticationService.logout().then(() => {
      this.historyService.push(FOUNDATION_ROUTES.LOGIN);
    });
  }

  @HPMSOnSubmitTermUse('hpms-privacy-warning-service')
  onSubmitTermUse(): void {
    const { nrSeqUser, nrSeqPrivacy } = this.historyService.getCurrentRouteParams();

    if (nrSeqPrivacy !== 'undefined') {
      void HttpService.put(Endpoint.PUT.CONFIRM_READ_PRIVACY_WARNING, { nrSeqUser, nrSeqPrivacy }).then(() => {
        void this.checkTermUse(nrSeqUser);
      });
    }
  }

  private async checkTermUse(nrSeqUser: any): Promise<void> {
    await HttpService.get(Endpoint.GET.CHECK_TERMOS_USO, { nrSeqUser }).then(async (result) => {
      const { nrSequence } = result.body as Term;
      if (!nrSequence) {
        await HttpService.get(Endpoint.GET.TERM_USE_CURRENT, { nrSeqUser }).then(resp => {
          const { nrSequence } = resp.body as Term;
          if (nrSequence) {
            this.context.set({ nrSeqTerm: nrSequence });
            this.historyService.push(Route.ASSIGN_TERM_USE, { nrSeqTerm: nrSequence });
          } else {
            this.historyService.push(APPLICATION_ROUTES.PROVIDER_ACCREDITATION, { nrSeqUser });
          }
        });
      } else {
        this.historyService.push(APPLICATION_ROUTES.PROVIDER_ACCREDITATION, { nrSeqUser });
      }
    });
  }

}

export default AssignPrivacyWarningModalController;
